export default function createSlugFromTitle( title: string ): string {
  return title.toLowerCase()
      .replace('.', '_')
      .replace(' ', '-');
}
